module.exports = __webpack_public_path__ + "static/elevation-wrong-layer-do-419bc21649b3451025d6748e7cf7506e.png";